export default class Formatting
{
    constructor()
    {

    }

    paymentMethod (isCard, isCash) {

        return '';
        
        /*isCard = parseInt(isCard);
        isCash = parseInt(isCash);

        if (isCard == 1 && isCash == 1) {
            return BX.message("LPOST_DELIVERY_SOA_METHOD_PAY_CARD_OR_CASH");
        } else if (isCash == 1 && isCard == 0) {
            return BX.message("LPOST_DELIVERY_SOA_METHOD_PAY_CASH");
        } else if (isCash == 0 && isCard == 0) {
            return BX.message("LPOST_DELIVERY_SOA_METHOD_PAY_PREPAYMENT");
        }*/

    }

    getDayLogistic(days)
    {
        // dev
    }

    /**
     * @deprecated
     */
    dateDayDelivery(date = []){
        let selectList = BX.create('select');
        for(let day of date){
            BX.selectUtils.addNewOption(selectList, day, day);
        }
        selectList.classList.add("input-date-day-delivery")
        return selectList.outerHTML ;
    }

    /**
     * @deprecated
     */
    dateTimeDelivery(times){
        let selectList = BX.create('select');

        BX.selectUtils.addNewOption(selectList, '_0', times['_0']);
        delete times['_0'];

        Object.keys(times).forEach(i => {
            BX.selectUtils.addNewOption(selectList, i, times[i]);
        });
        selectList.classList.add("input-date-time-delivery");

        return selectList.outerHTML ;
    }

    timeWork (arTime, deliveryDay) {

        if (!arTime) return BX.message("LPOST_DELIVERY_SOA_TIME_CLOSE");

        let date = new Date();
        date.setDate(date.getDate() + deliveryDay);
        let days = BX.message("LPOST_DELIVERY_SOA_DAYS");

        for (let i = 0; i < arTime.length; i++) {
            let day = arTime[i];
            if (days.indexOf(day.Day) == date.getDay()) {
                let dayFrom = day.From.substring(0, day.From.length - 3);
                let dayTo = day.To.substring(0, day.To.length - 3);
                return dayFrom + " - " + dayTo;
            }
        }
    }
}